import { Listitem } from 'components/ListItem/ListItem';
import styles from './List.module.css';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  items: any[];
  parentId: number;
  /** Country / group row name passed to nested leagues (sidebar). */
  groupName?: string;
}

const INITIAL_LEAGUE_COUNT = 10;

export const List = ({ items, parentId, groupName }: Props) => {
  const [itemsToShow, setItemsToShow] = useState(
    items.slice(0, INITIAL_LEAGUE_COUNT)
  );
  const { t } = useTranslation();

  const handleShowMoreClick = () => {
    if (itemsToShow.length === items.length) {
      setItemsToShow(items.slice(0, INITIAL_LEAGUE_COUNT));
    } else {
      setItemsToShow([...items]);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.itemsWrapper}>
        {itemsToShow.map((i, index) => (
          <Listitem
            {...i}
            key={index}
            parentId={parentId}
            groupName={groupName}
          />
        ))}
        {items.length > INITIAL_LEAGUE_COUNT && (
          <div className={styles.showAll} onClick={handleShowMoreClick}>
            {itemsToShow.length === items.length
              ? t('show_less_label')
              : t('show_all_label')}
          </div>
        )}
      </div>
    </div>
  );
};
